// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_banner__2hW-X","closed":"banner_closed__2gYLA","inner":"banner_inner__3njbN","close":"banner_close__1fLlR"};